import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/sales/delivery-order/";

export function getDeliveriesBySo(salesOrderID = 0) {
  return http.get(apiEndpoint + "so-deliveries/" + salesOrderID);
}

export function getItemsToDeliverFromSalesOrder(salesOrderID) {
  return http.get(apiEndpoint + "so-items-to-deliver/" + salesOrderID);
}

export function saveSoDeliveryOrder(deliveryOrder) {
  return http.post(apiEndpoint, deliveryOrder);
}

export function getSoDeliveries() {
  return http.get(apiEndpoint);
}

export function getSoDeliveriesReservationComplete(warehouseID = 0) {
  return http.get(
    apiEndpoint + "so-deliveries-reserve-complete/" + warehouseID
  );
}

export function getSoDeliveryDetail(deliveryID = 0) {
  return http.get(apiEndpoint + "so-delivery-detail/" + deliveryID);
}

export function getPendingGiDeliveryOrder(warehouseID = 0) {
  return http.get(apiEndpoint + "pending-gi-delivery-order/" + warehouseID);
}

export function getDeliveryOrderItems(deliveryOrderID = 0) {
  return http.get(apiEndpoint + "delivery-order-items/" + deliveryOrderID);
}

export function cancelDeliveryOrder(deliveryOrderID = 0) {
  return http.delete(apiEndpoint + "cancel-delivery-order/" + deliveryOrderID);
}
